export const Users = [
    {
      id:1,
      profilePicture: "assets/person/1.jpeg",
      username: "Alice",
    },
    {
      id:2,
      profilePicture: "assets/person/2.jpeg",
      username: "Uncle John",
    },
    {
      id:3,
      profilePicture: "assets/person/3.jpeg",
      username: "Azeria",
    },
    {
      id:4,
      profilePicture: "assets/person/4.jpeg",
      username: "Amanda",
    },
    {
      id:5,
      profilePicture: "assets/person/5.jpeg",
      username: "Alexender",
    },
    {
      id:6,
      profilePicture: "assets/person/6.jpeg",
      username: "Dan",
    },
    {
      id:7,
      profilePicture: "assets/person/7.jpeg",
      username: "Head Joy",
    },
    {
      id:8,
      profilePicture: "assets/person/8.jpeg",
      username: "Evil Sky",
    },
    {
      id:9,
      profilePicture: "assets/person/9.jpeg",
      username: "Krypto",
    },
    {
      id:10,
      profilePicture: "assets/person/10.jpeg",
      username: "Knight Long",
    },
  ];
  
  export const Posts = [
    {
      id: 1,
      desc: "If you truly love nature, you will find beauty everywhere.",
      photo: "assets/post/1.jpeg",
      date: "5 mins ago",
      userId: 1,
      like: 32,
      comment: 9,
    },
    {
      id: 2,
      photo: "assets/post/2.jpeg",
      date: "15 mins ago",
      userId: 2,
      like: 2,
      comment: 1,
    },
    {
      id: 3,
      desc: "Leave the road, take the trails. ",
      photo: "assets/post/3.jpeg",
      date: "1 hour ago",
      userId: 3,
      like: 61,
      comment: 2,
    },
    {
      id: 4,
      photo: "assets/post/4.jpeg",
      date: "4 hours ago",
      userId: 4,
      like: 7,
      comment: 3,
    },
    {
      id: 5,
      photo: "assets/post/5.jpeg",
      date: "5 hours ago",
      userId: 5,
      like: 23,
      comment: 5,
    },
    {
      id: 6,
      photo: "assets/post/6.jpeg",
      date: "1 day ago",
      userId: 6,
      like: 44,
      comment: 6,
    },
    {
      id: 7,
      desc: "Never regret anything that made you smile.",
      photo: "assets/post/7.jpeg",
      date: "2 days ago",
      userId: 7,
      like: 52,
      comment: 3,
    },
    {
      id: 8,
      photo: "assets/post/8.jpeg",
      date: "3 days ago",
      userId: 8,
      like: 15,
      comment: 1,
    },
    {
      id: 9,
      photo: "assets/post/9.jpeg",
      date: "5 days ago",
      userId: 9,
      like: 11,
      comment: 2,
    },
    {
      id: 10,
      desc: "Be Yourself !  ",
      photo: "assets/post/10.jpeg",
      date: "1 week ago",
      userId: 10,
      like: 104,
      comment: 12,
    },
  ];